import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../shared/message.service';
import { MessageType } from '../../shared/messageType';

@Component({
    selector: 're-generic-error',
    templateUrl: './generic-error.component.html',
    styleUrls: ['./generic-error.component.scss'],
    standalone: false
})
export class GenericErrorComponent {
  message = "There was an error while loading the application."
  constructor(private messages: MessageService, private route: ActivatedRoute, location: Location) {
    let state :any= location.getState();
    this.messages.hideSpinner(); //just in case we forgot to hide it
    this.messages.send(MessageType.HideMenu);
    if (this.route.snapshot.queryParams.returnUrl) {
      this.returnUrl = window.location.origin + this.route.snapshot.queryParams.returnUrl;
    }
    if (state && state.message) {
      this.message = state.message;
    }
  }

  returnUrl = null;

}
